import { Link, Section, Title } from '../base-ui'
import { MediaQuery } from '../base-ui/Utility'
import Image from 'next/image'
import { css, useTheme } from '@emotion/react'
import { useRouter } from 'next/router'

function PageHeader({
    color = 'lighterGray',
    title,
    highlight,
    parallax = true,
    highlightColor = 'primary',
    breadcrumb = [],
    style
}) {
    const { locale } = useRouter()
    const theme = useTheme()
    const breadcrumbStyle = css`
        display: flex;
        ${MediaQuery('md', 'max')} {
            justify-content: center;
        }
        .breadcrumb-item {
            display: flex;
            align-items: center;
            .breadcrumb-splitter {
                display: flex;
                align-items: center;
            }
        }
        .breadcrumb-item:last-child {
            a {
                color: ${theme.colors.primary};
            }
            .breadcrumb-splitter {
                display: none;
            }
        }
    `
    const containerStyle = `padding: 5rem 0 5rem 0; ${style}`

    return (
        <Section
            backgroundImage="/img/home/how/home-how-background.jpg"
            style={containerStyle}
            parallax={parallax}
        >
            <Title
                color={color}
                highlightColor={highlightColor}
                highlight={highlight}
                imgSrc="/img/svg/title-line.svg"
                style={`${MediaQuery(
                    'md',
                    'max'
                )} {justify-content: center; .typography{text-align: center;};}`}
            >
                {title}
            </Title>
            <div className="breadcrumb" css={breadcrumbStyle}>
                {breadcrumb.map((item, idx) => (
                    <div key={idx} className="breadcrumb-item">
                        {item.url && (
                            <Link href={item.url} color="lighterGray">
                                {item.text}
                            </Link>
                        )}
                        {!item.url && item.text}
                        <span
                            className={`breadcrumb-splitter mx-2 ${
                                locale === 'en' && 'rotate-180'
                            }`}
                        >
                            <Image
                                alt="breadcrumb-item"
                                src="/img/svg/arrowLeft-primary.svg"
                                width={22}
                                height={22}
                            />
                        </span>
                    </div>
                ))}
            </div>
        </Section>
    )
}

export default PageHeader
